module.exports = __webpack_public_path__ + "static/media/Pag-Premio-Ebit-02.bc5cebbb.png";